/**
 * Product accordion: sync key ingredients with selected variant (shade)
 */
(function() {
  function normalizeOptionKey(value) {
    return (value || '')
      .toLowerCase()
      .replace(/[()]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function initIngredientsViewMore(root) {
    root.querySelectorAll('.key-ingredients .product-ingredients').forEach(function(ingredientBlock) {
      if (ingredientBlock.dataset.ingredientsViewMoreReady === 'true') return;
      var existingToggleButton = ingredientBlock.querySelector('.ingredients-view-more');
      var existingRemainingWrapper = ingredientBlock.querySelector('.ingredients-remaining');
      if (existingToggleButton && existingRemainingWrapper) {
        existingToggleButton.addEventListener('click', function() {
          var isExpanded = existingToggleButton.getAttribute('aria-expanded') === 'true';
          var willExpand = !isExpanded;
          existingToggleButton.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
          existingToggleButton.textContent = willExpand ? 'View less' : 'View more';
          existingRemainingWrapper.hidden = !willExpand;

          if (willExpand) {
            existingRemainingWrapper.insertAdjacentElement('afterend', existingToggleButton);
          } else {
            existingRemainingWrapper.insertAdjacentElement('beforebegin', existingToggleButton);
          }
        });
        ingredientBlock.dataset.ingredientsViewMoreReady = 'true';
        return;
      }

      var markerPattern = /<h[1-6][^>]*>\s*view all ingredients\s*<\/h[1-6]>/i;
      var html = ingredientBlock.innerHTML;
      var markerMatch = html.match(markerPattern);
      if (!markerMatch) return;

      var markerHtml = markerMatch[0];
      var markerIndex = html.search(markerPattern);
      var beforeMarkerHtml = html.slice(0, markerIndex + markerHtml.length);
      var afterMarkerHtml = html.slice(markerIndex + markerHtml.length);

      var tempContainer = document.createElement('div');
      tempContainer.innerHTML = afterMarkerHtml;

      var nonEmptyParagraphs = Array.from(tempContainer.querySelectorAll('p')).filter(function(paragraphNode) {
        return paragraphNode.textContent.replace(/\s+/g, '').length > 0;
      });

      if (nonEmptyParagraphs.length <= 1) {
        ingredientBlock.dataset.ingredientsViewMoreReady = 'true';
        return;
      }

      var firstParagraphHtml = nonEmptyParagraphs[0].outerHTML;
      nonEmptyParagraphs[0].remove();
      var remainingHtml = tempContainer.innerHTML;
      ingredientBlock.innerHTML = beforeMarkerHtml + firstParagraphHtml + '<button type="button" class="ingredients-view-more" aria-expanded="false">View more</button><div class="ingredients-remaining" hidden>' + remainingHtml + '</div>';

      var toggleButton = ingredientBlock.querySelector('.ingredients-view-more');
      var remainingWrapper = ingredientBlock.querySelector('.ingredients-remaining');

      if (toggleButton && remainingWrapper) {
        toggleButton.addEventListener('click', function() {
          var isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
          var willExpand = !isExpanded;
          toggleButton.setAttribute('aria-expanded', willExpand ? 'true' : 'false');
          toggleButton.textContent = willExpand ? 'View less' : 'View more';
          remainingWrapper.hidden = !willExpand;

          if (willExpand) {
            remainingWrapper.insertAdjacentElement('afterend', toggleButton);
          } else {
            remainingWrapper.insertAdjacentElement('beforebegin', toggleButton);
          }
        });
      }
      ingredientBlock.dataset.ingredientsViewMoreReady = 'true';
    });
  }

  initIngredientsViewMore(document);

  const targetShade = document.querySelector('.option-value');
  if (!targetShade) return;

  const observer = new MutationObserver(function() {
    const currentShade = targetShade.textContent.trim();
    const clean = normalizeOptionKey(currentShade);
    document.querySelectorAll('.product-accordion-only .key-ingredients').forEach(function(ingredients) {
      var allIngredientBlocks = ingredients.querySelectorAll('.product-ingredients');
      allIngredientBlocks.forEach(function(el) {
        el.classList.add('hide');
      });

      var match = null;
      if (clean) {
        match = ingredients.querySelector('[data-option-key="' + clean + '"]') || ingredients.querySelector('.' + clean);
      }
      if (!match) {
        match = ingredients.querySelector('.product-ingredients:not([data-option-key])') || allIngredientBlocks[0] || null;
      }
      if (match) {
        match.classList.remove('hide');
        initIngredientsViewMore(match.closest('.product-accordion-only') || document);
      }
    });
  });

  observer.observe(targetShade, { childList: true, characterData: true, subtree: true });
})();
